module.exports = __webpack_public_path__ + "img/bank-mark-as-reviewed-disabled.df4d5e91.svg";